module.exports = __webpack_public_path__ + "img/edit-yellow-icon.9e6788d8.svg";